import { Component } from '@angular/core';
import {AllFarmaciaComponent} from "./all-farmacia/all-farmacia.component";

@Component({
  selector: 'app-farmacia',
  standalone: true,
  imports: [
    AllFarmaciaComponent
  ],
  templateUrl: './farmacia.component.html',
  styleUrl: './farmacia.component.css'
})
export class FarmaciaComponent {

}
